<template>
  <div :class="`field-wrapper field-wrapper-edit ${textAlign} ${classes}`">
    <el-input
      class="field-input-number"
      :size="size"
      :clearable="clearable"
      :disabled="disabled"
      :placeholder="placeholder"
      v-model="selfValue"
      @keyup.native="onKeyup"
      @afterpaste.native="onAfterpaste"
      @change="onChange"
    >
      <template v-if="$slots.prepend" #prepend>
        <slot name="prepend" />
      </template>
      <template v-if="$slots.prefix" #prefix><slot name="prefix" /></template>
      <slot />
      <template v-if="$slots.append" #append><slot name="append" /></template>
      <template v-if="$slots.suffix" #suffix><slot name="suffix" /></template>
    </el-input>
  </div>
</template>

<script>
// import _ from "lodash"
import math from "@libs/js/mathjs";
import { useFormatAmount } from "@libs/js/formatAmount";

const { validAmount, isReservedSymbol, inputNumberFilter } = useFormatAmount();

export default {
  name: "inputNumber",
  props: {
    value: { type: [Number, String], default: "" },
    classes: { type: String, default: "" },
    textAlign: { type: String, default: "right" },
    size: { type: String, default: "default" },
    label: { type: String, default: "" },
    prop: { type: String, default: "" },
    rules: { type: Object, default: undefined },
    placeholder: { type: String, default: "请填写" },
    tooltip: { type: String, default: undefined },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    // 数值类型
    // "int" | "+int" | "-int" | undefined
    type: { type: String, default: undefined },
    // 小数点后位数
    fractionLength: { type: Number, default: 0 },
    // 默认空值
    emptyValue: { type: [Number, String, null], default: undefined },
  },
  // emits: ["input", "change"],

  data() {
    return {};
  },
  computed: {
    selfValue: {
      get() {
        return this.invalidValue(this.value);
      },
      set(newValue) {
        // console.log("selfValue:", newValue, this.invalidValue(newValue))
        this.$emit("input", this.invalidValue(newValue));
      },
    },
  },
  methods: {
    // 数值有效性验证
    invalidValue(val) {
      if (isReservedSymbol(val)) {
        return val;
      }
      if (validAmount(val)) {
        return val;
      }
      return "";
    },

    onKeyup(evt) {
      this.selfValue = evt.target.value = inputNumberFilter(
        evt.target.value,
        this.type
      );
    },
    onAfterpaste(evt) {
      this.selfValue = evt.target.value = inputNumberFilter(
        evt.target.value,
        this.type
      );
    },
    onChange(val) {
      if (isReservedSymbol(val)) {
        // 操作中间状态，未完成有效输入
        this.selfValue = val = "";
      }
      if (this.type === undefined) {
        if (val === "" && this.emptyValue !== undefined) {
          this.selfValue = val = this.emptyValue;
        } else {
          // 矫正保留小数
          this.selfValue = val = math.format(math.bignumber(val), {
            notation: "fixed",
            precision: this.fractionLength,
            isBankToFixed: false,
          });
        }
      }
      this.$emit("change", val);
    },
  },
};
</script>

<style lang="less" scoped>
@table-bg-color: #f2f6ff;
@amount-font-family: "DIN", "DIN-Bold";

.field-wrapper {
  position: relative;
}
.field-wrapper.field-wrapper-edit {
  .field-input-number {
    :deep(.el-input__inner) {
      // 商户端统一字体样式，不使用DIN作为金额字体
      // font-family: @amount-font-family;
      font-size: 15px;
    }
    &.el-input--small,
    &.el-input--mini {
      :deep(.el-input__inner) {
        font-size: 14px;
      }
    }
  }
}

.left {
  .field-input-number {
    :deep(.el-input__inner) {
      text-align: left;
    }
  }
}
.right {
  .field-input-number {
    :deep(.el-input__inner) {
      text-align: right;
    }
  }
}
</style>
